import {Show, VStack} from 'platform/foundation';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {Main} from '@dms/shared';

import {isNotNilOrEmpty, useRequiredParams} from 'shared/web';

import {RentalInspectionPhotos} from './components/RentalInspectionPhotos';

export function RentalOrderPhotos() {
  const {id: rentalOrderId} = useRequiredParams();
  const {data: rentalOrder} = useGetRentalOrderQuery({rentalOrderId});

  const rentInspectionId = rentalOrder?.rentVehicleInspections?.[0];
  const returnInspectionId = rentalOrder?.returnVehicleInspections?.[0];

  return (
    <Main>
      <VStack spacing={4}>
        <Show when={isNotNilOrEmpty(rentInspectionId)}>
          <RentalInspectionPhotos
            inspectionId={rentInspectionId}
            title={i18n.t('page.rentalOrder.labels.rentVehicleInspection')}
          />
        </Show>
        <Show when={isNotNilOrEmpty(returnInspectionId)}>
          <RentalInspectionPhotos
            inspectionId={returnInspectionId}
            title={i18n.t('page.rentalOrder.labels.returnVehicleInspection')}
          />
        </Show>
      </VStack>
    </Main>
  );
}
